import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Add as AddIcon, HelpOutline as HelpIcon } from "@mui/icons-material";
import { Box, Collapse, IconButton, Paper, Tooltip, Typography } from "@mui/material";
import { useState } from "react";
export const FilterAccordion = ({ label, icon: _Icon, tooltip, isActive = false, children, defaultExpanded = false, }) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    return (_jsxs(Paper, Object.assign({ sx: {
            overflow: "hidden",
            "&:not(:last-child)": {
                borderBottom: 1,
                borderColor: "divider",
            },
            "&:hover": {
                bgcolor: "action.hover",
            },
        }, elevation: 0 }, { children: [_jsxs(Box, Object.assign({ onClick: () => setExpanded(!expanded), sx: {
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    px: 2,
                    py: 1.5,
                    cursor: "pointer",
                    borderLeft: isActive ? "3px solid" : "3px solid transparent",
                    borderLeftColor: isActive ? "primary.main" : "transparent",
                } }, { children: [_jsx(Typography, Object.assign({ variant: "body2", sx: {
                            flex: 1,
                            fontWeight: isActive ? 600 : 400,
                            color: isActive ? "primary.main" : "text.secondary",
                            fontSize: "14px",
                        } }, { children: label })), tooltip && (_jsx(Tooltip, Object.assign({ title: tooltip, arrow: true, placement: "top" }, { children: _jsx(IconButton, Object.assign({ size: "small", onClick: (e) => e.stopPropagation(), sx: { p: 0.25 } }, { children: _jsx(HelpIcon, { sx: { fontSize: 16, color: "action.active" } }) })) }))), _jsx(IconButton, Object.assign({ size: "small", sx: {
                            p: 0.5,
                            color: "action.active",
                        } }, { children: _jsx(AddIcon, { sx: { fontSize: 18 } }) }))] })), _jsx(Collapse, Object.assign({ in: expanded }, { children: _jsx(Box, Object.assign({ sx: { px: 2, pb: 2, pt: 0, bgcolor: "background.default" } }, { children: children })) }))] })));
};
export default FilterAccordion;
